import { installViteAssetLoader } from '@/runtime/core/install-vite-asset-loader.runtime';

installViteAssetLoader();
